// extracted by mini-css-extract-plugin
module.exports = {"icon":"CompanyPreview_icon__2ZO6E","buttonWrapper":"CompanyPreview_buttonWrapper__1exVU","backButton":"CompanyPreview_backButton__ctOUm components_buttonNoStyle__1q5IH"};